"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("promise-polyfill/src/polyfill");
require("whatwg-fetch");
function liveProgramTitle() {
    fetch('/nuopbnrjsonp', {
        credentials: "include",
        method: 'GET'
    }).then(function (data) { return data.json(); }).then(function (json) {
        document.querySelector('button.radio .program-title').textContent = json.currentItem.title;
    })
        .catch(function (e) {
        console.error(e);
    });
}
liveProgramTitle();
